export default __webpack_public_path__ + "static/media/raheelh.c43661e5.gif";